
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import TimePicker from "@/components/TimePicker.vue"

@Component({
  components: { DatePicker, TimePicker },
})
export default class RssPublishDate extends Vue {
  get date(): string {
    return this.innerDate(this.rssPublishedAt)
  }

  get time(): string {
    return this.innerTime(this.rssPublishedAt)
  }
  @Prop()
  private articleId!: number
  @Prop()
  private rssPublishedAt!: string

  @Emit("rssPublishedAt")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitRssPublishedAt(datetime: string) {
    /** */
  }

  private changeDate(newDate: string) {
    if (newDate !== "" && newDate !== null) {
      const time = this.time ? this.time : "00:00"
      this.emitRssPublishedAt(newDate + " " + time)
    } else {
      this.emitRssPublishedAt("")
    }
  }

  private changeTime(newTime: string) {
    const oldDate = this.date
    if (oldDate) {
      if (newTime !== "" && newTime !== null) {
        this.emitRssPublishedAt(oldDate + " " + newTime)
      } else {
        this.emitRssPublishedAt(oldDate + " " + "00:00")
      }
    }
  }

  private innerDate(date: string): string {
    return date !== "" && date !== null ? date.split(" ")[0] : ""
  }

  private innerTime(date: string): string {
    if (date !== "" && date !== null) {
      const time = date.split(" ")[1]
      if (time !== "00:00:00") {
        return time
      } else {
        return ""
      }
    } else {
      return ""
    }
  }
}
